import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { Button } from '@material-ui/core';
import { useRecoilValue } from 'recoil';
import { multiPanelAtom } from '@/state/atom/panelAtom';
import { I18n } from 'aws-amplify';

export default function HeaderButton({
    panelId,
    detailTicket,
    handleSubmitEditTicket,
    handleSoftDeleteTicket,
    selectedProject,
    currentUserDetail,
    corporationDetail,
    handleArchiveTicket,
    isSoftDelete,
    isGeneralUserWithGuest,
    setIsConfirmDialogObj,
    setIsShowDialogRestoreTicket,
    isDisableBtnSaveTicket,
    replyToEmailTicket,
    onClickCancelReplyTicket,
    handleBackToArrivalTicket,
    currentTicketDeliverStatus,
    isEdited,
    isDisableBtnSave,
    currentTicketIsEdited,
    triggerEnableBtnSaveTicket,
    setReplyConfirm,
    replyConfirm,
    isReplyEditData,
    handleCloseTab
}) {

    const panelList = useRecoilValue(multiPanelAtom);

    const onClickButtonClose = () => {
        if (replyToEmailTicket) {
            if (isReplyEditData) {
                return setReplyConfirm({...replyConfirm, isAction: 'reply', isOpen: true});
            }
            return onClickCancelReplyTicket()
        
        }

        if (currentTicketIsEdited()) {
            return setReplyConfirm({...replyConfirm, isAction: 'editEmail', isOpen: true});
        }

        return handleCloseTab(isEdited)
    };

    const getPanelType = () => {
        let currentPanelIndex = Utils.findIndexInArrayById(panelId, panelList);
        if (currentPanelIndex === -1) return '';
        let currentPanel = panelList[currentPanelIndex];
        return currentPanel.type;
    };

    const isDisplayButtonArchivedTicket = () => {
        if (
            selectedProject.id !== detailTicket.affiliationProject &&
            (currentUserDetail?.id === detailTicket.customer || selectedProject.id === detailTicket.customer)
        ) {
            return false;
        }

        if (replyToEmailTicket) return false;

        return (
            selectedProject.id === detailTicket.affiliationProject &&
            detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC &&
            detailTicket.liveOrArchived !== Constant.LIVE_OR_ARCHIVED.ARCHIVED &&
            !detailTicket.deletedAt

        );
    };

    const isDisplayButtonSoftDeleteTicket = () => {
        if (replyToEmailTicket) return false;
        if (
            [Constant.TICKET_TYPE.EMAIL].includes(detailTicket?.ticketType) &&
            selectedProject.id === detailTicket.affiliationProject  &&
            !detailTicket.deletedAt
        ) {
            return true;
        }
 
        return false;
    };

    const renderBtnCompletedDeleteAndRestoreTicket = () => {
        if (
            (isSoftDelete  && isGeneralUserWithGuest) &&
            !Utils.isDisabledTicketExternalWhenDeskServiceOff(detailTicket, corporationDetail)
        ) {
            return (
                <>
                    <Button
                        className="btn-send btn-delete btn-hg32"
                        variant="contained"
                        color="primary"
                        onClick={() => setIsConfirmDialogObj(true)}
                    >
                        {I18n.get('HELPDESK_HARD_DELETE')}
                    </Button>
                    <Button
                        className="btn-send btn-outline-primary btn-hg32"
                        variant="contained"
                        color="primary"
                        onClick={() => setIsShowDialogRestoreTicket(true)}
                    >
                        {I18n.get('HELPDESK_RESTORE')}
                    </Button>
                </>
            );
        }
    };

    const isDisplayButtonCancelTicket = () => {
        return (
            detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC &&
            detailTicket.liveOrArchived !== Constant.LIVE_OR_ARCHIVED.ARCHIVED &&
            (detailTicket.ticketType === Constant.TICKET_TYPE.EMAIL
                // detailTicket.ticketType === Constant.TICKET_TYPE.ESCALATION ||
            )
        );
    };

    const isDisplayButtonEditTicket = () => {
        return (
            detailTicket.liveOrArchived !== Constant.LIVE_OR_ARCHIVED.ARCHIVED &&
            detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC
        );
    };

    const isDisplayButtonCluster = () => {
        if(isSoftDelete) return false;
        return (
            isDisplayButtonEditTicket() ||
            isDisplayButtonArchivedTicket() ||
            isDisplayButtonCancelTicket() ||
            isDisplayButtonSoftDeleteTicket()
        );
    };

    const isDisplayButtonBackToArrival = () => {
        if (
            selectedProject.id !== detailTicket.affiliationProject &&
            (currentUserDetail?.id === detailTicket.customer ||
                selectedProject.id === detailTicket.customer)
        ) {
            return false;
        }

        if (replyToEmailTicket) return false;

        return (
            selectedProject.id === detailTicket.affiliationProject &&
            detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC &&
            detailTicket.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED &&
            !detailTicket.deletedAt
        );
    };

    const isDisableBtnCancel = () => {
        // has reply ticket
        if (replyToEmailTicket) return false;

        // has edit current ticket
        if (currentTicketIsEdited()) return false;

        if (!isEdited) return true;

        return false;
    }
    
    return (
        <div className='col2'>
        <div className='itemAddticket edit-ticket-btn'>
            <div class="wrap-btn-add">
                {isDisplayButtonCluster() && (
                    <>
                        {isDisplayButtonSoftDeleteTicket() && (
                            <Button
                                className="btn-send btn-delete btn-hg32"
                                variant="contained"
                                color="primary"
                                onClick={handleSoftDeleteTicket}
                            >
                                {I18n.get('COMBTN013')}
                            </Button>
                        )}
                        {isDisplayButtonArchivedTicket() &&
                            getPanelType() !==
                                Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL && (
                                <Button
                                    className="btn-send btn-light btn-hg32"
                                    variant="contained"
                                    color="primary"
                                    onClick={handleArchiveTicket}
                                >
                                    {I18n.get('HELPDESK_ARCHIVE')}
                                </Button>
                            )}
                        {isDisplayButtonBackToArrival() &&
                            getPanelType() !==
                                Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL && (
                                <Button
                                    className="btn-send btn-outline-primary btn-hg32 btn-back-to-arrival"
                                    variant="contained"
                                    color="primary"
                                    onClick={handleBackToArrivalTicket}
                                >
                                    {I18n.get('HELPDESK_BACK_TO_NEW_SUPPORT')}
                                </Button>
                            )
                        }
                        {/* { isDisplayButtonCancelTicket() && 
                            <Button  
                                className="btn-send btn-light btn-hg32" 
                                variant="contained" 
                                color="primary" 
                                disabled={isDisableBtnCancel()}
                                onClick={onClickButtonClose}
                            >
                                {I18n.get('CM-BUTTON-CANCEL')}
                            </Button>
                        } */}
                        { isDisplayButtonEditTicket() && 
                            <Button 
                                className="btn-send btn-primary btn-hg32" 
                                variant="contained" 
                                color="primary" 
                                onClick={handleSubmitEditTicket()} 
                                data-cy="btn-submit-add-ticket"
                                disabled={isDisableBtnSave}
                            >
                                {replyToEmailTicket || currentTicketDeliverStatus ? I18n.get('USER04BTN001'): I18n.get('COMBTN011')}
                            </Button>
                        }
                    </>
                )}
                { renderBtnCompletedDeleteAndRestoreTicket() }
            </div>
        </div>
    </div>
    );
}
